<template>
  <div>
    <PatternHero
      size="medium"
      color-class="text-primary-400"
      icon-for-type="Set"
    >
      <div class="p-6 md:pl-0">
        <h2 class="text-mobile-2xl font-semibold md:text-2xl">
          {{ set.title }}
        </h2>
        <div
          v-if="locale === 'fr' && set.summary"
          class="text-mobile-lg md:mt-2 md:text-lg"
          v-html="set.summary"
        />
        <div
          v-else="locale === 'fr'"
          class="text-mobile-lg md:mt-2 md:text-lg"
          v-html="set.summaryEn"
        />
      </div>
    </PatternHero>
    <div class="mx-auto max-w-7xl px-6 pt-6 md:pt-10 xl:px-0">
      <p class="text-shade-500">
        {{ $t('event.media_count', searchCount) }}
      </p>
      <div class="grid grid-cols-resource-card gap-6 md:mt-10 md:gap-14">
        <CardResource
          v-for="card in set.medias.map((media) => ({
            ...media,
            image: media.cardImage,
          }))"
          :key="card.id"
          :resource="card"
        />
      </div>
      <div class="mt-4 flex justify-center md:mt-10 md:justify-start">
        <DataPagination
          v-model="currentPage"
          :count="searchCount"
          :page-size="pageSize"
          @update:modelValue="updateUrl()"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { getSetBySlug } from '~/queries/set'

let { currentPage, query } = useSearchParams()
const route = useRoute()
const router = useRouter()
query = ref(query)
currentPage = ref(currentPage)
watch(
  () => route.query.p,
  (newValue) => {
    currentPage.value = newValue ?? 1
  }
)

let pageSize = ref(21)
const { formatToFullDate } = useFullDateFormater()

const { locale } = useI18n()

const { slug } = useResourceSlug()
const { data, pending, error } = await useAsyncData(
  `/set/${slug}/`,
  () =>
    execQuery(getSetBySlug, {
      slug,
      limit: pageSize.value,
      offset: (currentPage.value - 1) * pageSize.value,
    }),
  { watch: [pageSize, currentPage] }
)
const searchCount = computed<Collection[]>(() => {
  if (pending.value || error.value) return []
  return data.value.data.setBySlug.total
})
const set = computed(() => {
  if (pending.value || error.value) return {}
  return data.value.data.setBySlug
})

const title = computed(() => {
  return set.value?.title
})

const description = computed(() => {
  return removeHtml(set.value?.summary)
})

useHead({
  title,
  meta: [
    {
      name: 'description',
      content: description,
    },
  ],
})

useSeoMeta({
  title,
  ogTitle: title,
  description,
  ogDescription: description,
  ogImage: set.value?.image?.getUrl,
  twitterCard: 'summary',
})
async function updateUrl() {
  const _query = {
    p: currentPage.value,
  }

  await router.push({
    query: _query,
  })
}
function formatMedia(media) {
  if (!media) return null
  return {
    subtitle: media.description,
    excerpt: `${media.timestamp ? formatToFullDate(media.timestamp) : ''} ${
      media.duration ?? ''
    }`,
    ...media,
  }
}
</script>
